import { rgba, tint } from 'polished';
import styled from 'styled-components';

export const CustomTable = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;

  .ant-table {
    min-height: 0.01%;
    overflow-y: auto;
    overflow-x: auto;
    font-size: 14px;
    font-weight: 400;
    background-color: ${({ theme }) => theme.palette.background.paper};

    thead > tr > th,
    thead > tr > td {
      font-size: 14px;
      font-weight: 500;
      color: ${({ theme }) => theme.palette.neutral[400]};
      padding: 10px 26px;
      background: ${({ theme }) => theme.palette.background.paper};
      white-space: nowrap;
    }

    /* Selection column padding — works for both normal (<td>) and virtual (<div>) */
    thead > tr > th.ant-table-selection-column,
    thead > tr > td.ant-table-selection-column,
    tbody > tr > th.ant-table-selection-column,
    tbody > tr > td.ant-table-selection-column,
    tfoot > tr > th.ant-table-selection-column,
    tfoot > tr > td.ant-table-selection-column,
    .ant-table-row > .ant-table-cell.ant-table-selection-column {
      padding: 14px;
    }

    /* Body cell styles — works for both normal (<td>) and virtual (<div>) */
    tbody > tr > th,
    tbody > tr > td,
    tfoot > tr > th,
    tfoot > tr > td,
    .ant-table-row > .ant-table-cell {
      font-size: 14px;
      font-weight: 500;
      padding: 16px 24px;
      color: ${({ theme }) => theme.palette.neutral[700]};
      white-space: wrap;
    }

    /* Non-virtual: force native scroll on .ant-table-body */
    &:not(.ant-table-virtual) .ant-table-body {
      overflow-y: auto !important;
      overflow-x: auto !important;
    }

    .table-actions {
      display: flex;
      justify-content: center;
      align-items: center;
      cursor: pointer;
      > li:not(:last-child) {
        margin-right: 16px;
      }
      a img {
        width: 16px;
        height: 16px;
      }
      .anticon {
        font-size: 16px;
      }
    }

    @media screen and (max-width: 767px) {
      width: 100%;
      overflow-y: hidden;
      -ms-overflow-style: -ms-autohiding-scrollbar;
    }

    .ant-table-row:hover {
      cursor: default;
    }

    /* Action icons/buttons/dropdowns inside table cells should show pointer */
    .ant-table-cell .anticon,
    .ant-table-cell button,
    .ant-table-cell a,
    .ant-table-cell svg,
    .ant-table-cell .ant-dropdown-trigger,
    .ant-table-cell [role="button"],
    .table-actions li {
      cursor: pointer;
    }

    /* Custom table row selection styles — works for both normal and virtual */
    .ant-table-tbody > tr.ant-table-row-selected > td,
    .ant-table-row.ant-table-row-selected > .ant-table-cell {
      background-color: white !important;
    }

    .ant-table-tbody > tr.ant-table-row-selected:hover > td,
    .ant-table-row.ant-table-row-selected:hover > .ant-table-cell {
      background-color: white !important;
    }

    .ant-table-tbody
      > tr.ant-table-row-selected
      .ant-checkbox-checked
      .ant-checkbox-inner::after,
    .ant-table-row.ant-table-row-selected
      .ant-checkbox-checked
      .ant-checkbox-inner::after {
      border-color: white !important;
    }
    /* END */

    /* Custom checkbox styles with white background and brand color */
    .ant-checkbox .ant-checkbox-inner {
      background-color: white !important;
    }

    .ant-checkbox-checked .ant-checkbox-inner {
      background-color: #00795b !important;
      border-color: #00795b !important;
    }

    .ant-checkbox-checked .ant-checkbox-inner::after,
    .ant-checkbox-indeterminate .ant-checkbox-inner::after {
      border-color: white !important;
      background-color: #00795b !important;
    }

    .ant-checkbox:hover .ant-checkbox-inner {
      border-color: #00795b !important;
    }

    .ant-checkbox-inner {
      border-color: #00795b !important;
    }

    .ant-checkbox-input:focus + .ant-checkbox-inner {
      border-color: #00795b !important;
      box-shadow: 0 0 0 2px #00795b !important;
    }
    /* END */

    /* Fixed/sticky columns: solid background to prevent content bleed-through */
    .ant-table-cell-fix-left,
    .ant-table-cell-fix-right {
      background-color: ${({ theme }) => theme.palette.background.paper};
    }

    .ant-table-row-selected .ant-table-cell-fix-left,
    .ant-table-row-selected .ant-table-cell-fix-right {
      background-color: white !important;
    }

    .ant-table-expanded-row > td.ant-table-cell {
      background-color: ${({ theme }) => theme.palette.white};
    }

    /* Error row — works for both normal and virtual */
    .ant-table-tbody > tr.error-row > td,
    .ant-table-row.error-row > .ant-table-cell {
      color: ${({ theme }) => theme.palette.red[500]} !important;
    }

    .ant-table-row-selected-custom,
    .ant-table-row-selected-custom:hover,
    .ant-table-row-selected-custom > .ant-table-cell,
    .ant-table-row-selected-custom > .ant-table-cell:hover {
      background-color: ${({ theme }) => theme.palette.primary[50]} !important;
    }
  }

  /* ── Unified row hover — at CustomTable root level ──
     hoverColor class is on .ant-table-wrapper (antd puts className there).
     Must be outside .ant-table {} block to match the DOM hierarchy:
     CustomTable > .ant-table-wrapper.hoverColor > ... > .ant-table > ... > rows */
  .hoverColor .ant-table-row:hover > td,
  .hoverColor .ant-table-row:hover > .ant-table-cell {
    background-color: ${({ theme }) =>
      rgba(theme.palette.secondary.main, 0.1)} !important;
  }

  /* Fixed columns on hover: opaque background to prevent content bleed-through */
  .hoverColor .ant-table-row:hover > .ant-table-cell-fix-left,
  .hoverColor .ant-table-row:hover > .ant-table-cell-fix-right {
    background-color: ${({ theme }) =>
      tint(0.9, theme.palette.secondary.main)} !important;
  }
`;
